import React from 'react';
import PropTypes from 'prop-types';
import { PROJECT_PROGRESS_TYPE_ENUM } from '~/modules/projects/project/common/enums/projectProgressType';
import { ProgressChartLoading } from '~/modules/common/charts/dashboard';
import { ProgressCostChart } from '~/modules/projects/project/charts/ProgressCostChart';
import { ProgressHourChart } from '~/modules/projects/project/charts/ProgressHourChart';
import { useProjectProgresSummary } from '~/modules/projects/project/charts/hooks/useProjectProgressSummary';
import { useMeContext } from '~/modules/me/useMeContext';

export const ProjectProgressChart = ({ chartDataInput }) => {
  const { isRolledUpTaskEstimateCalculationMethodEnabled } = useMeContext();

  const {
    projectId,
    showCostContent,
    projectProgressView,
    projectCurrency,
    projectProgressCardSettingsLoading
  } = chartDataInput;

  const {
    hourSummary,
    costSummary,
    isLoading,
    error
  } = useProjectProgresSummary({
    projectId,
    isRolledUpTaskEstimateCalculationMethodEnabled,
    projectProgressView,
    skip: projectProgressCardSettingsLoading
  });

  if (projectProgressCardSettingsLoading) return <ProgressChartLoading />;

  return (
    <>
      {showCostContent &&
      projectProgressView === PROJECT_PROGRESS_TYPE_ENUM.COST ? (
        <>
          <ProgressCostChart
            projectCurrency={projectCurrency}
            summary={costSummary}
            isLoading={isLoading}
            error={error}
          />
        </>
      ) : (
        <ProgressHourChart
          summary={hourSummary}
          isLoading={isLoading}
          error={error}
        />
      )}
    </>
  );
};

ProjectProgressChart.propTypes = {
  chartDataInput: PropTypes.object
};

export default ProjectProgressChart;
